<template>
  <div>
    <div class="row">
      <div class="col-xl-9 m-b-10">
        <b-card no-body>
          <b-table
            id="itemTable"
            striped
            fixed
            responsive
            sort-icon-left
            show-empty
            empty-text="There are no matching items to show"
            :items="this.itemsInType()"
            :per-page="perPage"
            :current-page="currentPage"
            :fields="fields"
          >
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'image' ? '120px' : '100px' }"
              />
            </template>
            <template v-slot:head(selected)>
              <b-form-checkbox
                v-if="$route.params.type == 'service'"
                v-model="servicesCheck"
                @change="checkAllServices"
                >Select all</b-form-checkbox
              >
              <b-form-checkbox
                v-else-if="$route.params.type == 'space'"
                v-model="spacesCheck"
                @change="checkAllSpaces"
                >Select all</b-form-checkbox
              >
              <b-form-checkbox
                v-else-if="$route.params.type == 'staff'"
                v-model="staffCheck"
                @change="checkAllStaff"
                >Select all</b-form-checkbox
              >
              <b-form-checkbox
                v-else-if="$route.params.type == 'stuff'"
                v-model="stuffCheck"
                @change="checkAllStuff"
                >Select all</b-form-checkbox
              >
            </template>
            <template v-slot:head(subcategory)>
              {{ subcategoryLabel }}
            </template>
            <template v-slot:head(category)>
              {{ categoryLabel }}
            </template>
            <template v-slot:cell(selected)="{ item }">
              <b-form-checkbox
                size="lg"
                :value="item"
                v-model="selectedItems"
                @change="itemCheck"
              />
            </template>
            <template v-slot:cell(image)="{ item }">
              <img :src="getImage(item.image)" height="65px" />
            </template>
            <template v-slot:cell(subcategory)="{ item }">
              {{ categoryName(item.category) }}
            </template>
            <template v-slot:cell(category)="{ item }">
              {{ categoryParent(item.category) }}
            </template>
            <template v-slot:cell(inUse)="{ item }">
              {{ checkUsage(item.id) }} {{ item.unit }}
            </template>
            <template v-slot:cell(amount)="{ item }">
              {{ item.amount }} {{ item.unit }}
            </template>
            <template v-slot:cell(actions)="{ item }">
              <url-button
                label="View details"
                :url="`/eventbank/${$route.params.type}/items/` + item.id"
                class="btn-yellow"
              />
            </template>
          </b-table>
        </b-card>
      </div>
      <div class="col-xl-3">
        <div>
          <div role="tablist">
            <b-card no-body class="p-0">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.tab1 variant="light"
                  >Filters</b-button
                >
              </b-card-header>
              <b-collapse id="tab1" visible role="tabpanel">
                <b-card-body>
                  <label class="width-full"
                    ><b>Search:</b>
                    <input
                      v-model="search"
                      placeholder="Search item"
                      type="search"
                      class="form-control"
                    />
                  </label>
                  <label class="width-full"
                    ><b>Uncategorized items:</b>
                    <b-form-checkbox switch v-model="onlyUncategorizedItems"
                      >Only uncategorized items</b-form-checkbox
                    >
                  </label>
                  <label class="width-full"
                    ><b>{{ categoryFilterLabel }}</b>
                    <select
                      v-model="categoryFilter"
                      class="form-control"
                      @change="subcategoryFilter = 'all'"
                    >
                      <option value="all" selected>All</option>
                      <option
                        v-for="category in this.parentCategories().sort(
                          (a, b) => (a.name > b.name ? 1 : -1)
                        )"
                        :key="category.id"
                        :value="category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </label>
                  <label class="width-full"
                    ><b>{{ subcategoryFilterLabel }}</b>
                    <select v-model="subcategoryFilter" class="form-control">
                      <option value="all" selected>All</option>
                      <option
                        v-for="category in this.subcategories(false).sort(
                          (a, b) => (a.name > b.name ? 1 : -1)
                        )"
                        :key="category.id"
                        :value="category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </label>
                  <label class="width-full"
                    ><b>Source:</b>
                    <select v-model="source" class="form-control">
                      <option value="All" selected>All</option>
                      <option value="None">None</option>
                      <option value="Owned">Owned</option>
                      <option value="Contract">Contract</option>
                      <option value="Other">Other</option>
                    </select>
                  </label>
                  <label class="width-full"
                    ><b>Planning status:</b>
                    <select v-model="status" class="form-control">
                      <option value="all" selected>All</option>
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                    </select>
                  </label>
                  <input-button
                    type="button"
                    @click="resetFilters"
                    label="Reset filters"
                    class="btn-yellow mt-2"
                  />
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="p-0">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.tab2 variant="light"
                  >Selected Items</b-button
                >
              </b-card-header>
              <b-collapse id="tab2" visible role="tabpanel">
                <b-card-body>
                  <b-card-text>
                    <p v-if="!selectedItems.length">No items selected.</p>
                    <ul>
                      <li
                        class="mb-2"
                        v-for="(selectedItem, index) in selectedItems"
                        :key="selectedItem.id"
                      >
                        {{ selectedItem.name }}
                        <b-button
                          v-b-tooltip.left="'Unselect item'"
                          class="
                            btn btn-danger btn-icon btn-circle btn-sm
                            pull-right
                          "
                          @click="unselect(index)"
                        >
                          <i class="fa fa-times" />
                        </b-button>
                      </li>
                    </ul>
                  </b-card-text>
                  <div v-if="selectedItems.length">
                    <label class="width-full"
                      ><b>Action:</b>
                      <select v-model="action" class="form-control">
                        <option value="add">Send to script</option>
                        <option value="view">View all</option>
                        <option value="edit">Change category</option>
                        <option value="delete">Delete items</option>
                      </select>
                    </label>
                    <b-button @click="selectAction" class="btn-yellow"
                      >Select</b-button
                    >
                    <input-button
                      type="button"
                      @click="unselectAll"
                      label="Unselect all"
                      class="btn-danger pull-right"
                    />
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      centered
      v-model="modal"
      title="Bulk edit"
      ok-title="Save"
      ok-variant="yellow"
      @ok="save()"
      cancel-variant="white"
    >
      <select v-model="categoryId" class="form-control">
        <option selected disabled value="0">Select category</option>
        <option
          v-for="category in this.subcategories(true)"
          :key="category.id"
          :value="category.id"
        >
          {{ category.name }}
        </option>
      </select>
    </b-modal>

    <div class="row m-t-10">
      <div class="col-6">
        <label
          ><b>Per page</b>
          <b-form-select v-model="perPage" :options="perPageOptions" />
        </label>
      </div>
      <b-pagination
        class="col-6 pagination"
        next-class="{ background-color: red; }"
        align="right"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="itemTable"
      />
    </div>

    <div class="height-50">
      <hr />
      <url-button
        label="Create new"
        :url="$route.path + '/new'"
        class="btn-yellow pull-right"
      />
    </div>

    <b-modal
      ref="modalAlert"
      centered
      title="Delete selected items"
      cancel-variant="white"
      ok-variant="danger"
      ok-title="Delete"
      v-on:ok="deleteItems"
      scrollable
    >
      <div class="alert alert-danger m-b-0">
        <h5><i class="fa fa-info-circle"></i>Delete</h5>
        <p>Are you sure you want to delete these items?</p>

        <ul>
          <li v-for="selectedItem in selectedItems" :key="selectedItem.id">
            {{ selectedItem.name }}
          </li>
        </ul>
      </div>
    </b-modal>

    <add-to-script-modal
      ref="childModal"
      :itemToAdd="null"
      :itemsToAdd="selectedItems"
    />

    <b-modal
      ref="modalViewAll"
      size="xl"
      centered
      title="Selected items"
      class="row"
      hide-footer
    >
      <div class="col-12">
        <div v-if="currentItem">
          <div class="row">
            <div class="col-xl-6">
              <b-card
                class="m-b-20"
                :title="currentItem.name"
                :img-src="getImage(currentItem.image)"
                img-alt="Image"
                img-top
                bg-variant="dark"
                text-variant="light"
              >
                <b-card-text>{{ currentItem.description }} </b-card-text>
              </b-card>
            </div>
            <div class="col-xl-6">
              <b-card
                class="m-b-20"
                header-tag="header"
                header-bg-variant="dark"
                header-text-variant="light"
              >
                <template v-slot:header>
                  <h6 class="mb-0">Details</h6>
                </template>
                <b-card-text>
                  <b>Name: </b><span>{{ currentItem.name }}</span
                  ><br />
                  <b>{{ mainCategoryTitle }}: </b>
                  <span v-if="currentItem.category">{{
                    this.getMainCategory(currentItem.category.parent)
                  }}</span>
                  <span v-else>None</span> <br />
                  <b>{{ subcategoryTitle }}: </b>
                  <span v-if="currentItem.category">{{
                    currentItem.category.name
                  }}</span>
                  <span v-else>None</span> <br />
                  <b>Source: </b>{{ currentItem.source }} <br />
                  <b>Total: </b>{{ currentItem.amount }} {{ currentItem.unit }}
                  <br />
                  <b>Unit price: </b>{{ currentItem.unitPrice }}
                </b-card-text>
              </b-card>
              <b-card
                class="m-b-20"
                header-tag="header"
                header-bg-variant="dark"
                header-text-variant="light"
              >
                <template v-slot:header>
                  <h6 class="mb-0">Script data</h6>
                </template>
                <b-card-text>
                  <div>
                    <b>Number of active items: </b
                    ><span>{{ activeNumber }}</span
                    ><br />
                    <b>Storyboards where used: </b>
                    <p v-if="!storyboardsWhereUsed.length">None</p>
                    <ul>
                      <li
                        v-for="storyboard in storyboardsWhereUsed"
                        :key="storyboard.id"
                      >
                        {{ storyboard.name }}
                      </li>
                    </ul>
                    <b>Stages where used: </b>
                    <p v-if="!stagesWhereUsed.length">None</p>
                    <ul>
                      <li v-for="stage in stagesWhereUsed" :key="stage.id">
                        {{ stage.name }}
                      </li>
                    </ul>
                    <b>Steps where used: </b>
                    <p v-if="!stepsWhereUsed.length">None</p>
                    <ul>
                      <li
                        class="m-b-20"
                        v-for="step in stepsWhereUsed"
                        :key="step.id"
                      >
                        {{ step.name }}
                        <url-button
                          label="Go to"
                          :url="`/script/space/` + step.id"
                          class="btn-yellow btn-sm pull-right"
                        />
                      </li>
                    </ul>
                  </div>
                </b-card-text>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <b-card
                class="m-b-20"
                header-tag="header"
                header-bg-variant="dark"
                header-text-variant="light"
              >
                <template v-slot:header>
                  <h6 class="mb-0">Files</h6>
                </template>
                <b-card-text>
                  <vue-custom-scrollbar class="height-sm">
                    <div class="row">
                      <div
                        class="m-20 text-center"
                        v-for="file in currentItem.files"
                        :key="file.id"
                      >
                        <a
                          :href="fileUrl + file.fileFd"
                          :download="file.fileFd"
                        >
                          <i
                            v-if="fileType(file.fileFd) == 'pdf'"
                            class="fas fa-file-pdf fa-5x"
                          />
                          <i
                            v-else-if="
                              fileType(file.fileFd) == ('jpg' || 'jpeg')
                            "
                            class="fas fa-file-image fa-5x"
                          />
                          <p class="text-black">{{ file.name }}</p>
                        </a>
                      </div>
                    </div>
                    <div v-if="!currentItem.files.length">
                      <p class="m-l-10">No files</p>
                    </div>
                  </vue-custom-scrollbar>
                </b-card-text>
              </b-card>
            </div>
            <div class="col-xl-6">
              <b-card
                header-tag="header"
                header-bg-variant="dark"
                header-text-variant="light"
              >
                <template v-slot:header>
                  <h6 class="mb-0">Notes</h6>
                </template>
                <b-card-text>
                  <vue-custom-scrollbar class="height-sm">
                    <ul
                      class="media-list media-list-with-divider media-messaging"
                    >
                      <li
                        class="media media-sm"
                        v-for="(note, index) in currentItem.notes"
                        :key="note.id"
                      >
                        <div class="media-body">
                          <h5 class="media-heading">Note #{{ index + 1 }}</h5>
                          <p>{{ note.content }}</p>
                        </div>
                      </li>
                      <li
                        v-if="!currentItem.notes.length"
                        class="media media-sm"
                      >
                        <div class="media-body">
                          <p>No notes</p>
                        </div>
                      </li>
                    </ul>
                  </vue-custom-scrollbar>
                </b-card-text>
              </b-card>
            </div>
          </div>
          <b-card
            class="m-b-20"
            header-tag="header"
            header-bg-variant="dark"
            header-text-variant="light"
          >
            <template v-slot:header>
              <h6 class="mb-0">Actions</h6>
            </template>
            <b-button @click="addToScript" class="btn-yellow pull-right mr-1"
              >Add to script</b-button
            >
          </b-card>
        </div>
        <b-card bg-variant="dark" text-variant="light">
          <b-row>
            <b-col>
              <button
                @click="previousItem"
                class="btn btn-yellow btn-icon btn-circle btn-lg"
              >
                <i class="fa fa-chevron-left" />
              </button>
            </b-col>
            <b-col class="text-center">
              <!--<b-list-group horizontal>
                                <b-list-group-item class="text-center" button @click="toItem(index)" v-for="(selectedItem, index) in selectedItems" :key="selectedItem.id">{{ selectedItem.name }}</b-list-group-item>
                            </b-list-group>-->
              <h2>{{ index + 1 }} / {{ selectedItems.length }}</h2>
            </b-col>
            <b-col>
              <button
                @click="nextItem"
                class="btn btn-yellow btn-icon btn-circle btn-lg pull-right"
              >
                <i class="fa fa-chevron-right" />
              </button>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UrlButton from '../buttons/UrlButton.vue'
import InputButton from '../buttons/InputButton.vue'
import AddToScriptModal from './AddToScriptModal.vue'

export default {
  name: 'ItemTable',
  props: ['typeId', 'items', 'categories', 'scriptItems', 'activeEvent'],
  components: {
    UrlButton,
    InputButton,
    AddToScriptModal
  },
  data() {
    return {
      subcategoryLabel: 'Area',
      categoryLabel: 'Venue',
      servicesCheck: false,
      spacesCheck: false,
      staffCheck: false,
      stuffCheck: false,
      selectedItems: [],
      categoryFilterLabel: 'Venue:',
      subcategoryFilterLabel: 'Area:',
      categoryFilter: 'all',
      subcategoryFilter: 'all',
      source: 'All',
      status: 'all',
      search: '',
      onlyUncategorizedItems: false,
      action: 'add',
      modal: false,
      index: 0,
      currentItem: null,
      categoryId: 0,
      perPageOptions: [5, 10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      fields: [
        { key: 'selected', sortable: false },
        { key: 'image', sortable: false },
        { key: 'name', sortable: true },
        { key: 'subcategory', sortable: true },
        { key: 'category', sortable: true },
        { key: 'amount', label: 'Total', sortable: true },
        { key: 'inUse', label: 'Active', sortable: true },
        { key: 'source', sortable: true },
        { key: 'actions', sortable: false }
      ],
      mainCategoryTitle: 'Service category',
      subcategoryTitle: 'Service area',
      activeNumber: 0,
      stepsWhereUsed: [],
      stagesWhereUsed: [],
      storyboardsWhereUsed: [],
      fileUrl: process.env.VUE_APP_API_URL + '/uploads/files/'
    }
  },
  computed: {
    rows() {
      return this.itemsInType().length
    },
    ...mapState('storyboard', ['storyboards']),
    ...mapState('stage', ['stages']),
    ...mapState('step', ['steps']),
    itemsWithCalculatedValues() {
      const items = this.items.map((item) => {
        item.inUse = 0
        this.scriptItems.forEach((scriptItem) => {
          if (scriptItem.item && item.id === scriptItem.item.id) {
            item.inUse += scriptItem.amount
          }
        })
        return item
      })
      return items
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    ...mapActions('storyboard', ['getStoryboards']),
    ...mapActions('stage', ['getStages']),
    ...mapActions('step', ['getSteps']),
    getImage(image) {
      if (image == null) {
        return require('../../assets/images/no_image.jpg')
      } else {
        return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
    },
    getUsage() {
      this.activeNumber = 0
      let stepArray = []
      let stageArray = []
      let storyboardArray = []
      this.scriptItems.forEach((scriptItem) => {
        if (scriptItem.item.id == this.currentItem.id) {
          this.activeNumber += scriptItem.amount
          this.steps.forEach((step) => {
            if (step.id == scriptItem.step.id) {
              stepArray.push(step)
              this.stages.forEach((stage) => {
                if (stage.id == step.stage) {
                  stageArray.push(stage)
                  this.storyboards.forEach((storyboard) => {
                    if (storyboard.id == stage.storyboard) {
                      storyboardArray.push(storyboard)
                    }
                  })
                }
              })
            }
          })
        }
      })
      this.stepsWhereUsed = [...new Set(stepArray)]
      this.stagesWhereUsed = [...new Set(stageArray)]
      this.storyboardsWhereUsed = [...new Set(storyboardArray)]
    },
    fileType(path) {
      return path.slice(path.lastIndexOf('.') + 1)
    },
    itemsInType() {
      let self = this
      return this.itemsWithCalculatedValues.filter(function (item) {
        if (item.type && item.type.id == self.typeId) {
          if (item.category == null) {
            if (
              self.categoryFilter == 'all' &&
              self.subcategoryFilter == 'all'
            ) {
              let sItem = self.scriptItems.find(
                (scriptItem) =>
                  scriptItem && scriptItem.item && scriptItem.item.id == item.id
              )
              if (sItem && sItem.amount > 0 && self.status == 'true') {
                if (
                  item.name.toLowerCase().includes(self.search.toLowerCase())
                ) {
                  return item
                }
              } else if (sItem == null && self.status == 'false') {
                if (
                  item.name.toLowerCase().includes(self.search.toLowerCase())
                ) {
                  return item
                }
              } else if (self.status == 'all') {
                if (
                  item.name.toLowerCase().includes(self.search.toLowerCase())
                ) {
                  return item
                }
              }
            }
          } else if (
            !self.onlyUncategorizedItems &&
            (item.category.parent == self.categoryFilter ||
              self.categoryFilter == 'all')
          ) {
            if (
              item.category.id == self.subcategoryFilter ||
              self.subcategoryFilter == 'all'
            ) {
              if (item.source == self.source || self.source == 'All') {
                let sItem = self.scriptItems.find(
                  (scriptItem) =>
                    scriptItem &&
                    scriptItem.item &&
                    scriptItem.item.id == item.id
                )
                if (sItem && sItem.amount > 0 && self.status == 'true') {
                  if (
                    item.name.toLowerCase().includes(self.search.toLowerCase())
                  ) {
                    return item
                  }
                } else if (sItem == null && self.status == 'false') {
                  if (
                    item.name.toLowerCase().includes(self.search.toLowerCase())
                  ) {
                    return item
                  }
                } else if (self.status == 'all') {
                  if (
                    item.name.toLowerCase().includes(self.search.toLowerCase())
                  ) {
                    return item
                  }
                }
              }
            }
          }
        }
      })
    },
    parentCategories() {
      let self = this
      let matchingCategories = []
      this.categories.filter(function (category) {
        if (category.type.id == self.typeId && !category.parent) {
          matchingCategories.push(category)
        }
      })
      return matchingCategories
    },
    subcategories(isChanging) {
      let subcategoriesInMainCategories = []
      let subcategoriesInType = []
      let parentCategory = this.categoryFilter
      if (parentCategory != 'all') {
        this.categories.forEach((category) => {
          if (category.parent) {
            if (category.parent.id == parentCategory) {
              subcategoriesInMainCategories.push(category)
            }
          }
        })
        return subcategoriesInMainCategories
      } else if (isChanging || parentCategory == 'all') {
        this.categories.forEach((category) => {
          if (category.type.id == this.typeId) {
            if (category.parent) {
              subcategoriesInType.push(category)
            }
          }
        })
        return subcategoriesInType
      }
    },
    categoryName(currentCategory) {
      if (currentCategory) {
        return currentCategory.name
      } else {
        return ''
      }
    },
    categoryParent(currentCategory) {
      if (currentCategory) {
        let parentName = ''
        this.categories.forEach((category) => {
          if (category.id == currentCategory.parent) {
            parentName = category.name
          }
        })
        return parentName
      } else {
        return ''
      }
    },
    getMainCategory(parentCategoryId) {
      let returnValue = 'None'
      this.categories.forEach((category) => {
        if (category.id == parentCategoryId) {
          returnValue = category.name
        }
      })
      return returnValue
    },
    checkUsage(currentItemId) {
      let amountInUse = 0
      this.scriptItems.forEach((scriptItem) => {
        if (
          scriptItem &&
          scriptItem.item &&
          currentItemId == scriptItem.item.id
        ) {
          amountInUse += scriptItem.amount
        }
      })
      return amountInUse
    },
    resetFilters() {
      this.search = ''
      this.onlyUncategorizedItems = false
      this.categoryFilter = 'all'
      this.subcategoryFilter = 'all'
      this.source = 'All'
      this.status = 'all'
    },
    selectAction() {
      switch (this.action) {
        case 'add':
          this.$refs['childModal'].$refs['modalAdd'].show()
          break
        case 'view':
          this.currentItem = this.selectedItems[0]
          this.$refs['modalViewAll'].show()
          this.showItemById(this.selectedItems[0].id)
          break
        case 'edit':
          this.modal = true
          break
        case 'delete':
          this.$refs['modalAlert'].show()
          break
        default:
          break
      }
    },
    save() {
      if (this.categoryId != 0) {
        this.selectedItems.forEach((selectedItem) => {
          this.$parent.$parent.$parent.bulkSubmit(
            selectedItem.id,
            JSON.stringify({
              categoryId: parseInt(this.categoryId)
            })
          )
        })
        this.unselectAll()
      }
    },
    deleteItems() {
      this.selectedItems.forEach((selectedItem) => {
        if (selectedItem.image) {
          this.$parent.$parent.$parent.removeImage(selectedItem.image.id)
        }
        selectedItem.files.forEach((file) => {
          this.$parent.$parent.$parent.removeFile(file.id)
        })
        selectedItem.notes.forEach((note) => {
          this.$parent.$parent.$parent.deleteNoteCall(note.id)
        })
        this.$parent.$parent.$parent.bulkDelete(selectedItem.id)
      })
      this.unselectAll()
    },
    checkAllServices(checked) {
      if (checked) {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          if (
            !this.selectedItems.find(
              (selectedItem) => selectedItem.id == itemInType.id
            )
          ) {
            this.selectedItems.push(itemInType)
          }
        })
      } else {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          let index = this.selectedItems.findIndex(
            (selectedItem) => selectedItem.id == itemInType.id
          )
          if (index != -1) {
            this.selectedItems.splice(index, 1)
          }
        })
      }
    },
    checkAllSpaces(checked) {
      if (checked) {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          if (
            !this.selectedItems.find(
              (selectedItem) => selectedItem.id == itemInType.id
            )
          ) {
            this.selectedItems.push(itemInType)
          }
        })
      } else {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          let index = this.selectedItems.findIndex(
            (selectedItem) => selectedItem.id == itemInType.id
          )
          if (index != -1) {
            this.selectedItems.splice(index, 1)
          }
        })
      }
    },
    checkAllStaff(checked) {
      if (checked) {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          if (
            !this.selectedItems.find(
              (selectedItem) => selectedItem.id == itemInType.id
            )
          ) {
            this.selectedItems.push(itemInType)
          }
        })
      } else {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          let index = this.selectedItems.findIndex(
            (selectedItem) => selectedItem.id == itemInType.id
          )
          if (index != -1) {
            this.selectedItems.splice(index, 1)
          }
        })
      }
    },
    checkAllStuff(checked) {
      if (checked) {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          if (
            !this.selectedItems.find(
              (selectedItem) => selectedItem.id == itemInType.id
            )
          ) {
            this.selectedItems.push(itemInType)
          }
        })
      } else {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          let index = this.selectedItems.findIndex(
            (selectedItem) => selectedItem.id == itemInType.id
          )
          if (index != -1) {
            this.selectedItems.splice(index, 1)
          }
        })
      }
    },
    itemCheck(checked) {
      if (!checked) {
        switch (this.typeId) {
          case 1:
            this.servicesCheck = false
            break
          case 2:
            this.spacesCheck = false
            break
          case 3:
            this.staffCheck = false
            break
          case 4:
            this.stuffCheck = false
            break
          default:
            break
        }
      }
    },
    unselect(index) {
      let type = this.selectedItems[index].category.type
      switch (type) {
        case 1:
          this.servicesCheck = false
          break
        case 2:
          this.spacesCheck = false
          break
        case 3:
          this.staffCheck = false
          break
        case 4:
          this.stuffCheck = false
          break
        default:
          break
      }
      this.selectedItems.splice(index, 1)
    },
    unselectAll() {
      this.selectedItems = []
      this.servicesCheck = false
      this.spacesCheck = false
      this.staffCheck = false
      this.stuffCheck = false
    },
    previousItem() {
      if (this.index == 0) {
        this.index = this.selectedItems.length - 1
      } else {
        this.index--
      }
      this.showItemById(this.selectedItems[this.index].id)
    },
    nextItem() {
      if (this.index == this.selectedItems.length - 1) {
        this.index = 0
      } else {
        this.index++
      }
      this.showItemById(this.selectedItems[this.index].id)
    },
    /*toItem(index) {
            this.showItemById(this.selectedItems[index].id);
            this.index = index;
        },*/
    showItemById(itemId) {
      this.selectedItems.forEach((selectedItem) => {
        if (selectedItem.id == itemId) {
          this.currentItem = selectedItem
        }
      })
      switch (this.currentItem.type.id) {
        case 1:
          this.mainCategoryTitle = 'Service category'
          this.subcategoryTitle = 'Service area'
          break
        case 2:
          this.mainCategoryTitle = 'Venue'
          this.subcategoryTitle = 'Area'
          break
        case 3:
          this.mainCategoryTitle = 'Group'
          this.subcategoryTitle = 'Team'
          break
        case 4:
          this.mainCategoryTitle = 'Main category'
          this.subcategoryTitle = 'Subcategory'
          break
        default:
          break
      }
    },
    addToScript() {
      this.$refs['childModal'].$refs['modalAdd'].show()
    },
    closeModal() {
      this.$refs['modalViewAll'].hide()
    },
    updateLabels() {
      switch (this.typeId) {
        case 1:
          this.subcategoryLabel = 'Area'
          this.categoryLabel = 'Category'
          this.categoryFilterLabel = 'Category:'
          this.subcategoryFilterLabel = 'Area:'
          break
        case 2:
          this.subcategoryLabel = 'Area'
          this.categoryLabel = 'Venue'
          this.categoryFilterLabel = 'Venue:'
          this.subcategoryFilterLabel = 'Area:'
          break
        case 3:
          this.subcategoryLabel = 'Team'
          this.categoryLabel = 'Group'
          this.categoryFilterLabel = 'Group:'
          this.subcategoryFilterLabel = 'Team:'
          break
        case 4:
          this.subcategoryLabel = 'Subcategory'
          this.categoryLabel = 'Main category'
          this.categoryFilterLabel = 'Main category:'
          this.subcategoryFilterLabel = 'Subcategory:'
          break
        default:
          break
      }
    }
  },
  watch: {
    $route() {
      this.resetFilters()
      this.$nextTick(() => {
        this.updateLabels()
      })
    },
    currentItem: function () {
      this.getUsage()
    }
  },
  created() {
    this.getStoryboards(this.activeEvent.id)
    this.getStages(this.activeEvent.id)
    this.getSteps(this.activeEvent.id)
  },
  mounted() {
    this.$nextTick(() => {
      this.updateLabels()
    })
  }
}
</script>
